<template>
  <div class="archive-calendar">
    <div class="archive-calendar-title">これまでの一覧</div>
    <div class="archive-calendar__table">
      <template v-for="(yearMonth, index) in yearMonthList">
        <div class="archive-calendar__table-tr" :key="index" v-if="yearMonth.month.length > 0">
          <div class="archive-calendar__table-th">{{ yearMonth.year }}</div>
          <div v-for="(month, i) in yearMonth.month" :key="i" class="archive-calendar__table-td">
            <router-link :to="archiveUrl(yearMonth.year, month)">{{ month }}月</router-link>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>


<script>
import axios from 'axios'

export default {
  data: function() {
    return {
      tagName: '',
      yearMonthList: []
    }
  },

  watch: {
    $routes: 'fetchData'
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    archiveUrl(year, month) {
      const tag = this.tagName
      if (this.$route.params.channel) {
        const channel = this.$route.params.channel
        return `/${channel}/tag/${tag}/${year}/${month}`
      }
      return `/tag/${tag}/${year}/${month}`
    },
    fetchData() {
      const name = this.$route.params.name
      if (name !== this.tagName) {
        const url = `https://cxapi.j-cast.com/search/tag/${name}/archive`
        axios.get(url).then(response => {
          const data = response.data
          const years = Object.keys(data)
          years.sort(function(a, b) {
            return a < b ? 1 : -1
          })
          const yearMonthList = []
          years.forEach(year => {
            let setData = {}
            const yearMonth = {
              year: Number(year),
              month: data[year]
            }
            yearMonthList.push(yearMonth)
          })
          this.$set(this, 'yearMonthList', yearMonthList)
          this.tagName = name
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import "../assets/scss/_mixins.scss";

@include media(tab) {
  .archive-calendar {
    text-align: left;
  }
  .archive-calendar-title {
    text-align: left;
  }
}

.archive-calendar__table {
  display: inline-block;
  margin: 10px auto 20px;
  font-size: 1.4em;
  &-tr {
    display: flex;
    @include media(sp) {
      display: block;
      border-bottom: 1px solid #eee;
      margin: 0 0 10px;
    }
  }
  &-th,
  &-td {
    padding: 5px;
    font-weight: bold;
  }
  &-th {
    padding-right: 8px;
    color: #888;
    @include media(sp) {
      display: block;
    }
  }
  &-td {
    @include media(sp) {
      display: inline-block;
    }
    &:hover {
      background-color: #ddd;
    }
    a {
      color: #000;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>

